import { render, staticRenderFns } from "./displacedMap.vue?vue&type=template&id=4d609d39"
import script from "./displacedMap.vue?vue&type=script&lang=js"
export * from "./displacedMap.vue?vue&type=script&lang=js"
import style0 from "./displacedMap.vue?vue&type=style&index=0&id=4d609d39&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports